module.exports = __webpack_public_path__ + "static/media/male.386a5cc1.jpg";